const allStandardLegalEnergy = [
  {
    id: "sv6-166",
    name: "Boomerang Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.    If this card is discarded by an effect of an attack used by the Pokémon this card is attached to, attach this card from your discard pile to that Pokémon after attacking.",
    ],
    number: "166",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/166.png",
      large: "https://images.pokemontcg.io/sv6/166_hires.png",
    },
    altArts: [
      {
        id: "sv6-166",
        number: "166",
        images: {
          small: "https://images.pokemontcg.io/sv6/166.png",
          large: "https://images.pokemontcg.io/sv6/166_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-84",
    name: "Bubbly Water Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Water Energy.\n\nThe Water Pokémon this card is attached to recovers from all Special Conditions and can't be affected by any Special Conditions.",
    ],
    number: "84",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-84/small",
      large: "https://images.scrydex.com/pokemon/me4-84/large",
    },
    altArts: [
      {
        id: "me4-84",
        number: "84",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-84/small",
          large: "https://images.scrydex.com/pokemon/me4-84/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-191",
    name: "Enriching Energy",
    supertype: "Energy",
    subtypes: ["Special", "ACE SPEC"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.  When you attach this card from your hand to a Pokémon, draw 4 cards.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "191",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/191.png",
      large: "https://images.pokemontcg.io/sv8/191_hires.png",
    },
    altArts: [
      {
        id: "sv8-191",
        number: "191",
        images: {
          small: "https://images.pokemontcg.io/sv8/191.png",
          large: "https://images.pokemontcg.io/sv8/191_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-86",
    name: "Growing Grass Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Grass Energy. The Grass Pokémon this card is attached to gets +20 HP.",
    ],
    number: "86",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-86/small",
      large: "https://images.scrydex.com/pokemon/me3-86/large",
    },
    altArts: [
      {
        id: "me3-86",
        number: "86",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-86/small",
          large: "https://images.scrydex.com/pokemon/me3-86/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "rsv10pt5-86",
    name: "Ignition Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "If this card is attached to 1 of your Pokémon, discard it at the end of your turn.  As long as this card is attached to a Pokémon, it provides Colorless Energy.  If this card is attached to an Evolution Pokémon, it provides ColorlessColorlessColorless Energy instead.",
    ],
    number: "86",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/rsv10pt5/86.png",
      large: "https://images.pokemontcg.io/rsv10pt5/86_hires.png",
    },
    altArts: [
      {
        id: "rsv10pt5-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/rsv10pt5/86.png",
          large: "https://images.pokemontcg.io/rsv10pt5/86_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2-124",
        number: "124",
        images: {
          small: "https://images.pokemontcg.io/me2/124.png",
          large: "https://images.pokemontcg.io/me2/124_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv8-252",
    name: "Jet Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.  When you attach this card from your hand to 1 of your Benched Pokémon, switch that Pokémon with your Active Pokémon.",
    ],
    number: "252",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv8/252.png",
      large: "https://images.pokemontcg.io/sv8/252_hires.png",
    },
    altArts: [
      {
        id: "sv8-252",
        number: "252",
        images: {
          small: "https://images.pokemontcg.io/sv8/252.png",
          large: "https://images.pokemontcg.io/sv8/252_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-167",
    name: "Legacy Energy",
    supertype: "Energy",
    subtypes: ["Special", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "As long as this card is attached to a Pokémon, it provides every type of Energy but provides only 1 Energy at a time.    If the Pokémon this card is attached to is Knocked Out by damage from an attack from your opponent's Pokémon, that player takes 1 fewer Prize card. This effect of your Legacy Energy can't be applied more than once per game.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "167",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/167.png",
      large: "https://images.pokemontcg.io/sv6/167_hires.png",
    },
    altArts: [
      {
        id: "sv6-167",
        number: "167",
        images: {
          small: "https://images.pokemontcg.io/sv6/167.png",
          large: "https://images.pokemontcg.io/sv6/167_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6-226",
    name: "Luminous Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides every type of Energy but provides only 1 Energy at a time.  If the Pokémon this card is attached to has any other Special Energy attached, this card provides Colorless Energy instead.",
    ],
    number: "226",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv6/226.png",
      large: "https://images.pokemontcg.io/sv6/226_hires.png",
    },
    altArts: [
      {
        id: "sv6-226",
        number: "226",
        images: {
          small: "https://images.pokemontcg.io/sv6/226.png",
          large: "https://images.pokemontcg.io/sv6/226_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-85",
    name: "Magnetic Metal Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Metal Energy.\n\nThe Metal Pokémon this card is attached to has no Retreat Cost.",
    ],
    number: "85",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-85/small",
      large: "https://images.scrydex.com/pokemon/me4-85/large",
    },
    altArts: [
      {
        id: "me4-85",
        number: "85",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-85/small",
          large: "https://images.scrydex.com/pokemon/me4-85/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-161",
    name: "Mist Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.    Prevent all effects of attacks used by your opponent's Pokémon done to the Pokémon this card is attached to. (Existing effects are not removed. Damage is not an effect.)",
    ],
    number: "161",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/161.png",
      large: "https://images.pokemontcg.io/sv5/161_hires.png",
    },
    altArts: [
      {
        id: "sv5-161",
        number: "161",
        images: {
          small: "https://images.pokemontcg.io/sv5/161.png",
          large: "https://images.pokemontcg.io/sv5/161_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv5-162",
    name: "Neo Upper Energy",
    supertype: "Energy",
    subtypes: ["Special", "ACE SPEC"],
    rules: [
      "You can't have more than 1 ACE SPEC card in your deck.",
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.  If this card is attached to a Stage 2 Pokémon, this card provides every type of Energy but provides only 2 Energy at a time.",
      "ACE SPEC: You can't have more than 1 ACE SPEC card in your deck.",
    ],
    number: "162",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "H",
    images: {
      small: "https://images.pokemontcg.io/sv5/162.png",
      large: "https://images.pokemontcg.io/sv5/162_hires.png",
    },
    altArts: [
      {
        id: "sv5-162",
        number: "162",
        images: {
          small: "https://images.pokemontcg.io/sv5/162.png",
          large: "https://images.pokemontcg.io/sv5/162_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me4-86",
    name: "Nitro Fire Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Fire Energy.\n \nIf this card is discarded by an effect of an attack used by the Fire Pokémon this card is attached to, put this card into your hand after attack damage and effects.",
    ],
    number: "86",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me4-86/small",
      large: "https://images.scrydex.com/pokemon/me4-86/large",
    },
    altArts: [
      {
        id: "me4-86",
        number: "86",
        images: {
          small: "https://images.scrydex.com/pokemon/me4-86/small",
          large: "https://images.scrydex.com/pokemon/me4-86/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "zsv10pt5-86",
    name: "Prism Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.  If this card is attached to a Basic Pokémon, this card provides every type of Energy but provides only 1 Energy at a time.",
    ],
    number: "86",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/zsv10pt5/86.png",
      large: "https://images.pokemontcg.io/zsv10pt5/86_hires.png",
    },
    altArts: [
      {
        id: "zsv10pt5-86",
        number: "86",
        images: {
          small: "https://images.pokemontcg.io/zsv10pt5/86.png",
          large: "https://images.pokemontcg.io/zsv10pt5/86_hires.png",
        },
        flavorText: "",
      },
      {
        id: "me2pt5-216",
        number: "216",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-216/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-216/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-87",
    name: "Rocky Fighting Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Fighting Energy. Prevent all effects of attacks used by your opponent's Pokémon done to the Fighting Pokémon this card is attached to. (Existing effects are not removed. Damage is not an effect.)",
    ],
    number: "87",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-87/small",
      large: "https://images.scrydex.com/pokemon/me3-87/large",
    },
    altArts: [
      {
        id: "me3-87",
        number: "87",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-87/small",
          large: "https://images.scrydex.com/pokemon/me3-87/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-83",
    name: "Shadowy Darkness Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Darkness Energy.\n \nAs long as the Darkness Pokémon this card is attached to is on your Bench, prevent all damage done to it by attacks from your opponent's Pokémon.",
    ],
    number: "83",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-83/small",
      large: "https://images.scrydex.com/pokemon/me5-83/large",
    },
    altArts: [
      {
        id: "me5-83",
        number: "83",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-83/small",
          large: "https://images.scrydex.com/pokemon/me5-83/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv9-159",
    name: "Spiky Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Colorless Energy.  If the Pokémon this card is attached to is in the Active Spot and is damaged by an attack from your opponent's Pokémon (even if this Pokémon is Knocked Out), put 2 damage counters on the Attacking Pokémon.",
    ],
    number: "159",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.pokemontcg.io/sv9/159.png",
      large: "https://images.pokemontcg.io/sv9/159_hires.png",
    },
    altArts: [
      {
        id: "sv9-159",
        number: "159",
        images: {
          small: "https://images.pokemontcg.io/sv9/159.png",
          large: "https://images.pokemontcg.io/sv9/159_hires.png",
        },
        flavorText: "",
      },
      {
        id: "sv9-190",
        number: "190",
        images: {
          small: "https://images.pokemontcg.io/sv9/190.png",
          large: "https://images.pokemontcg.io/sv9/190_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me2pt5-217",
    name: "Team Rocket's Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "This card can only be attached to a Team Rocket's Pokémon. If this card is attached to anything other than a Team Rocket's Pokémon, discard this card.  As long as this card is attached to a Pokémon, it provides 2 in any combination of Psychic Energy and Darkness Energy.",
    ],
    number: "217",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "I",
    images: {
      small: "https://images.scrydex.com/pokemon/me2pt5-217/small",
      large: "https://images.scrydex.com/pokemon/me2pt5-217/large",
    },
    altArts: [
      {
        id: "me2pt5-217",
        number: "217",
        images: {
          small: "https://images.scrydex.com/pokemon/me2pt5-217/small",
          large: "https://images.scrydex.com/pokemon/me2pt5-217/large",
        },
        flavorText: "",
      },
      {
        id: "sv10-182",
        number: "182",
        images: {
          small: "https://images.pokemontcg.io/sv10/182.png",
          large: "https://images.pokemontcg.io/sv10/182_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me3-88",
    name: "Telepathic Psychic Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Psychic Energy. When you attach this card from your hand to a Psychic Pokémon, search your deck for up to 2 Basic Psychic Pokémon and put them onto your Bench. Then, shuffle your deck.",
    ],
    number: "88",
    legalities: {
      standard: "Not Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me3-88/small",
      large: "https://images.scrydex.com/pokemon/me3-88/large",
    },
    altArts: [
      {
        id: "me3-88",
        number: "88",
        images: {
          small: "https://images.scrydex.com/pokemon/me3-88/small",
          large: "https://images.scrydex.com/pokemon/me3-88/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "me5-84",
    name: "Voltaic Lightning Energy",
    supertype: "Energy",
    subtypes: ["Special"],
    rules: [
      "As long as this card is attached to a Pokémon, it provides Lightning Energy.\n \nAttacks used by the Lightning Pokémon this card is attached to do 20 more damage to your opponent's Active Pokémon (before applying Weakness and Resistance).",
    ],
    number: "84",
    legalities: {
      standard: "Legal",
      unlimited: "Legal",
      expanded: "Legal",
    },
    regulationMark: "J",
    images: {
      small: "https://images.scrydex.com/pokemon/me5-84/small",
      large: "https://images.scrydex.com/pokemon/me5-84/large",
    },
    altArts: [
      {
        id: "me5-84",
        number: "84",
        images: {
          small: "https://images.scrydex.com/pokemon/me5-84/small",
          large: "https://images.scrydex.com/pokemon/me5-84/large",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-98",
    name: "Basic Darkness Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    types: ["Darkness"],
    number: "98",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/98.png",
      large: "https://images.pokemontcg.io/sv6pt5/98_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-98",
        number: "98",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/98.png",
          large: "https://images.pokemontcg.io/sv6pt5/98_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv1-258",
    name: "Basic Fighting Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    number: "258",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv1/258.png",
      large: "https://images.pokemontcg.io/sv1/258_hires.png",
    },
    altArts: [
      {
        id: "sv1-258",
        number: "258",
        images: {
          small: "https://images.pokemontcg.io/sv1/258.png",
          large: "https://images.pokemontcg.io/sv1/258_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv2-278",
    name: "Basic Grass Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    number: "278",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv2/278.png",
      large: "https://images.pokemontcg.io/sv2/278_hires.png",
    },
    altArts: [
      {
        id: "sv2-278",
        number: "278",
        images: {
          small: "https://images.pokemontcg.io/sv2/278.png",
          large: "https://images.pokemontcg.io/sv2/278_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv1-257",
    name: "Basic Lightning Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    number: "257",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv1/257.png",
      large: "https://images.pokemontcg.io/sv1/257_hires.png",
    },
    altArts: [
      {
        id: "sv1-257",
        number: "257",
        images: {
          small: "https://images.pokemontcg.io/sv1/257.png",
          large: "https://images.pokemontcg.io/sv1/257_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv6pt5-99",
    name: "Basic Metal Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    types: ["Metal"],
    number: "99",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv6pt5/99.png",
      large: "https://images.pokemontcg.io/sv6pt5/99_hires.png",
    },
    altArts: [
      {
        id: "sv6pt5-99",
        number: "99",
        images: {
          small: "https://images.pokemontcg.io/sv6pt5/99.png",
          large: "https://images.pokemontcg.io/sv6pt5/99_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv3pt5-207",
    name: "Basic Psychic Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    types: ["Psychic"],
    number: "207",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv3pt5/207.png",
      large: "https://images.pokemontcg.io/sv3pt5/207_hires.png",
    },
    altArts: [
      {
        id: "sv3pt5-207",
        number: "207",
        images: {
          small: "https://images.pokemontcg.io/sv3pt5/207.png",
          large: "https://images.pokemontcg.io/sv3pt5/207_hires.png",
        },
        flavorText: "",
      },
    ],
  },
  {
    id: "sv2-279",
    name: "Basic Water Energy",
    supertype: "Energy",
    subtypes: ["Basic"],
    number: "279",
    legalities: {
      unlimited: "Legal",
      standard: "Legal",
      expanded: "Legal",
    },
    images: {
      small: "https://images.pokemontcg.io/sv2/279.png",
      large: "https://images.pokemontcg.io/sv2/279_hires.png",
    },
    altArts: [
      {
        id: "sv2-279",
        number: "279",
        images: {
          small: "https://images.pokemontcg.io/sv2/279.png",
          large: "https://images.pokemontcg.io/sv2/279_hires.png",
        },
        flavorText: "",
      },
    ],
  },
];

allStandardLegalEnergy.forEach((energy) => {
  energy.name = energy.name.replace("Pokémon", "Pokemon");
  energy.rules?.forEach((rule) => {
    rule = rule.replace("Pokémon", "Pokemon");
  });
});

export default allStandardLegalEnergy;
